/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import isEmpty from 'is-empty';
import PropTypes from 'prop-types';

import DashboardMobileNav from '../../navigation.components/DashboardMobileNav';
import UserDashBoardSideNavigation from
  '../../dashboard.components/userDashBoard.components/UserDashBoardSideNavigation';
import UserDashBoardTopNavigation from
  '../../dashboard.components/userDashBoard.components/UserDashBoardTopNavigation';
import roboAdvisory, { deleteRoboAdvisoryError } from '../../../actions/roboAdvisory.actions/postRoboAdvisory';
import {
  roboAdvisoryValidateInputPhaseOne,
  roboAdvisoryValidateInputPhaseTwo,
  roboAdvisoryValidateInputPhaseThree,
  roboAdvisoryValidateInputPhaseFour,
  roboAdvisoryValidateInputPhaseFive,
  roboAdvisoryValidateInputPhaseSix,
  roboAdvisoryValidateInputPhaseSeven
} from '../../../middlewares/roboAdvisoryValidations';
import {
  ErrorAlertNotification
} from '../../commons/index';


/**
 * @class Questionaire
 */
class Questionaire extends Component {
  state = {
    whenToStartWithdrawingMoney: '',
    whenToStartSpendingMoney: '',
    knowledgeOfInvestment: '',
    investmentConcern: '',
    currrentlyOwnInvestment: '',
    investmentLoosingValue: '',
    annualReturns: '',
    errorPhaseOne: '',
    errorPhaseTwo: '',
    errorPhaseThree: '',
    errorPhaseFour: '',
    errorPhaseFive: '',
    errorPhaseSix: '',
    errorPhaseSeven: '',
    errors: '',
  }

  /**
  *
  *@param {*} number
  *@returns {*} - state
  */
  onClickFirstQuestion = (number) => {
    this.setState({
      whenToStartWithdrawingMoney: number
    });
  }

  /**
  *
  *@param {*} number
  *@returns {*} - state
  */
 onClickSecondQuestion = (number) => {
   this.setState({
     whenToStartSpendingMoney: number
   });
 }

 /**
  *
  *@param {*} number
  *@returns {*} - state
  */
 onClickThirdQuestion = (number) => {
   this.setState({
     knowledgeOfInvestment: number
   });
 }

 /**
  *
  *@param {*} number
  *@returns {*} - state
  */
 onClickFourthQuestion = (number) => {
   this.setState({
     investmentConcern: number
   });
 }

 /**
  *
  *@param {*} number
  *@returns {*} - state
  */
 onClickFifthQuestion = (number) => {
   this.setState({
     currrentlyOwnInvestment: number
   });
 }

 /**
  *
  *@param {*} number
  *@returns {*} - state
  */
 onClickSixthQuestion = (number) => {
   this.setState({
     investmentLoosingValue: number
   });
 }

 /**
  *
  *@param {*} number
  *@returns {*} - state
  */
 onClickSeventhQuestion = (number) => {
   this.setState({
     annualReturns: number
   });
 }

 onSubmit = () => {
   if (this.isValidOne() && this.isValidTwo() && this.isValidThree() && this.isValidFour() && this.isValidFive() && this.isValidSix() && this.isValidSeven()) {
     const {
       RoboAdvisory
     } = this.props;
     RoboAdvisory(this.state);
   } else {
     this.setState({
       errors: 'Ooops! something went wrong please try filling the form again.'
     });
   }
 }

  /**
   *
   * @param {*} event
   * @returns {*} - state
   */
  isValidOne = () => {
    const { errors, isValid } = roboAdvisoryValidateInputPhaseOne(
      this.state
    );
    if (!isValid) {
      this.setState({
        errorPhaseOne: errors
      });
    }
    return isValid;
  }

  /**
   *
   * @param {*} event
   * @returns {*} - state
   */
  isValidTwo = () => {
    const { errors, isValid } = roboAdvisoryValidateInputPhaseTwo(
      this.state
    );
    if (!isValid) {
      this.setState({
        errorPhaseTwo: errors
      });
    }
    return isValid;
  }

  /**
   *
   * @param {*} event
   * @returns {*} - state
   */
  isValidThree = () => {
    const { errors, isValid } = roboAdvisoryValidateInputPhaseThree(
      this.state
    );
    if (!isValid) {
      this.setState({
        errorPhaseThree: errors
      });
    }
    return isValid;
  }

  /**
   *
   * @param {*} event
   * @returns {*} - state
   */
  isValidFour = () => {
    const { errors, isValid } = roboAdvisoryValidateInputPhaseFour(
      this.state
    );
    if (!isValid) {
      this.setState({
        errorPhaseFour: errors
      });
    }
    return isValid;
  }


  /**
   *
   * @param {*} event
   * @returns {*} - state
   */
  isValidFive = () => {
    const { errors, isValid } = roboAdvisoryValidateInputPhaseFive(
      this.state
    );
    if (!isValid) {
      this.setState({
        errorPhaseFive: errors
      });
    }
    return isValid;
  }

  /**
   *
   * @param {*} event
   * @returns {*} - state
   */
  isValidSix = () => {
    const { errors, isValid } = roboAdvisoryValidateInputPhaseSix(
      this.state
    );
    if (!isValid) {
      this.setState({
        errorPhaseSix: errors
      });
    }
    return isValid;
  }

  /**
   *
   * @param {*} event
   * @returns {*} - state
   */
  isValidSeven = () => {
    const { errors, isValid } = roboAdvisoryValidateInputPhaseSeven(
      this.state
    );
    if (!isValid) {
      this.setState({
        errorPhaseSeven: errors
      });
    }
    return isValid;
  }

  handleDelete = () => {
    const {
      errorPhaseOne,
      errorPhaseTwo,
      errorPhaseThree,
      errorPhaseFour,
      errorPhaseFive,
      errorPhaseSix,
      errorPhaseSeven,
      errors,
      error,
    } = this.state;
    if (!isEmpty(errorPhaseOne)) {
      this.setState({
        errorPhaseOne: {}
      });
    }
    if (!isEmpty(errorPhaseTwo)) {
      this.setState({
        errorPhaseTwo: {}
      });
    }
    if (!isEmpty(errorPhaseThree)) {
      this.setState({
        errorPhaseThree: {}
      });
    }
    if (!isEmpty(errorPhaseFour)) {
      this.setState({
        errorPhaseFour: {}
      });
    }
    if (!isEmpty(errorPhaseFive)) {
      this.setState({
        errorPhaseFive: { }
      });
    }
    if (!isEmpty(errorPhaseSix)) {
      this.setState({
        errorPhaseSix: ''
      });
    }
    if (!isEmpty(errorPhaseSeven)) {
      this.setState({
        errorPhaseSeven: ''
      });
    }
    if (!isEmpty(errors)) {
      this.setState({
        errors: ''
      });
    }
    if (error) {
      const { DeleteRoboAdvisoryError } = this.props;
      DeleteRoboAdvisoryError();
    }
  }


  /**
   *
   * @returns {*} - render
   */
  render() {
    console.log('this.state :', this.state);
    const {
      errorPhaseOne,
      errorPhaseTwo,
      errorPhaseThree,
      errorPhaseFour,
      errorPhaseFive,
      errorPhaseSix,
      errorPhaseSeven,
      errors
    } = this.state;
    const {
      success,
      error,
      isLoading,
      history
    } = this.props;

    if (success) {
      return <Redirect to="/success" />;
    }


    const questionaire = (
      <section className="body_space">

        <div className="go_back">
          <span onClick={history.goBack}>
            <i className="fa fa-arrow-left" aria-hidden="true" />
            {' '}
            {'  '}
             Go Back
          </span>
        </div>

        <div className="question_main_wrapper">
          <div className="question_1">
            <div className="question_and_numbers">

              <span>
        Question 1 / 7
              </span>

              <p>
        When do you want to start withdrawing money?
              </p>

            </div>

            {
              !isEmpty(errorPhaseOne) ? (
                <ErrorAlertNotification
                  errors={errorPhaseOne.whenToStartWithdrawingMoney}
                  onClick={this.handleDelete}
                />
              ) : ''
          }

            {/* ================================ */}
            <div className="question_month_options">
              <div className="question_month_options_div">
                <div className="month_option" onClick={() => this.onClickFirstQuestion('1')}>
                  <p>
                    Less than three years
                  </p>
                </div>
                <div className="month_option" onClick={() => this.onClickFirstQuestion(3)}>
                  <p>
                    Three to five years
                  </p>
                </div>
                <div className="month_option" onClick={() => this.onClickFirstQuestion(7)}>
                  <p>
                    Six to ten years
                  </p>
                </div>
                <div className="month_option" onClick={() => this.onClickFirstQuestion(10)}>
                  <p>
                    Eleven years or more
                  </p>
                </div>
              </div>
            </div>

            <div className="next_question_btn">

              <div className="next_btn">
                <button className="next" type="button" id="to_question_two">
        Next
                  {' '}
                  <i className="fas fa-long-arrow-alt-right" />
                </button>
              </div>

            </div>
          </div>

          <div className="question_2">
            <div className="question_and_numbers">
              <span>
                Question 2 / 7
              </span>
              <p>
                I plan to begin withdrawing money from my investments in:
              </p>
            </div>

            {
              !isEmpty(errorPhaseTwo) ? (
                <ErrorAlertNotification
                  errors={errorPhaseTwo.whenToStartSpendingMoney}
                  onClick={this.handleDelete}
                />
              ) : ''
          }

            <div className="question_month_options">
              <div className="question_month_options_div">
                <div className="month_option" onClick={() => this.onClickSecondQuestion(0)}>
                  <p>
                     Less than three years
                  </p>
                </div>
                <div className="month_option" onClick={() => this.onClickSecondQuestion(1)}>
                  <p>
                    Two to five years
                  </p>
                </div>
                <div className="month_option" onClick={() => this.onClickSecondQuestion(4)}>
                  <p>
                    Six to ten years
                  </p>
                </div>
                <div className="month_option" onClick={() => this.onClickSecondQuestion(8)}>
                  <p>
                    Eleven years or more
                  </p>
                </div>
              </div>
            </div>

            <div className="next_question_btn">
              <div className="prev_btn">
                <button className="prev" type="button" id="back_to_question_one">
                  <i className="fas fa-long-arrow-alt-left" />
                  {' '}
Previous
                </button>
              </div>
              <div className="next_btn">
                <button className="next" type="button" id="to_question_three">
                            Next
                  {' '}
                  <i className="fas fa-long-arrow-alt-right" />
                </button>
              </div>
            </div>
          </div>

          <div className="question_3">
            <div className="question_and_numbers">
              <span>
                Question 3 / 7
              </span>
              <p>
                I would describe my Knowledge Of Investment:
              </p>
            </div>
            {
              !isEmpty(errorPhaseThree) ? (
                <ErrorAlertNotification
                  errors={errorPhaseThree.knowledgeOfInvestment}
                  onClick={this.handleDelete}
                />
              ) : ''
          }
            <div className="question_month_options">
              <div className="question_month_options_div">
                <div className="month_option" onClick={() => this.onClickThirdQuestion(0)}>
                  <p>
                    None
                  </p>
                </div>
                <div className="month_option" onClick={() => this.onClickThirdQuestion(3)}>
                  <p>
                    Limited
                  </p>
                </div>
                <div className="month_option" onClick={() => this.onClickThirdQuestion(7)}>
                  <p>
                   Good
                  </p>
                </div>
                <div className="month_option" onClick={() => this.onClickThirdQuestion(10)}>
                  <p>
                    Extensively
                  </p>

                </div>

              </div>
            </div>

            <div className="next_question_btn">
              <div className="prev_btn">
                <button className="prev" type="button" id="back_to_question_two">
                  <i className="fas fa-long-arrow-alt-left" />
                  {' '}
Previous
                </button>
              </div>
              <div className="next_btn">
                <button className="next" type="button" id="to_question_four">
                            Next
                  {' '}
                  <i className="fas fa-long-arrow-alt-right" />
                </button>
              </div>
            </div>
          </div>

          <div className="question_4">
            <div className="question_and_numbers">
              <span>
                Question 4 / 7
              </span>
              <p>
                When I invest my money I am
              </p>
            </div>

            {
              !isEmpty(errorPhaseFour) ? (
                <ErrorAlertNotification
                  errors={errorPhaseFour.investmentConcern}
                  onClick={this.handleDelete}
                />
              ) : ''
          }

            <div className="question_month_options">
              <div className="question_month_options_div">
                <div className="month_option"
                  onClick={() => this.onClickFourthQuestion(0)}
                >
                  <p>
                    Most concern about investment loosing value
                  </p>
                </div>

                <div className="month_option"
                  onClick={() => this.onClickFourthQuestion(4)}
                >
                  <p>
                     Equally concern about investment loosing or gaining value
                  </p>
                </div>
                <div className="month_option"
                  onClick={() => this.onClickFourthQuestion(8)}
                >
                  <p>
                    Most concern about investment gaining value
                  </p>
                </div>
              </div>
            </div>
            <div className="next_question_btn">
              <div className="prev_btn">
                <button className="prev" type="button" id="back_to_question_three">
                  <i className="fas fa-long-arrow-alt-left" />
                  {' '}
Previous
                </button>
              </div>

              <div className="next_btn">
                <button className="next" type="button" id="to_question_five">
                Next
                  {' '}
                  <i className="fas fa-long-arrow-alt-right" />
                </button>
              </div>
            </div>
          </div>

          <div className="question_5">
            <div className="question_and_numbers">
              <span>
                Question 5 / 7
              </span>
              <p>
                Select the investment you currently own:
              </p>
            </div>
            {
              !isEmpty(errorPhaseFive) ? (
                <ErrorAlertNotification
                  errors={errorPhaseFive.currrentlyOwnInvestment}
                  onClick={this.handleDelete}
                />
              ) : ''
          }
            <div className="question_month_options">
              <div className="question_month_options_div">
                <div className="month_option"
                  onClick={() => this.onClickFifthQuestion(3)}
                >
                  <p>
                    Bonds and or funds
                  </p>
                </div>
                <div className="month_option"
                  onClick={() => this.onClickFifthQuestion(6)}
                >
                  <p>
                    Stocks and or stock funds
                  </p>
                </div>
                <div className="month_option"
                  onClick={() => this.onClickFifthQuestion(8)}
                >
                  <p>
                    International securities and or international funds
                  </p>
                </div>
              </div>
            </div>

            <div className="next_question_btn">
              <div className="prev_btn">
                <button className="prev" type="button" id="back_to_question_four">
                  <i className="fas fa-long-arrow-alt-left" />
                  {' '}
Previous
                </button>
              </div>

              <div className="next_btn">
                <button className="next" type="button" id="to_question_six">
                    Next
                  {' '}
                  <i className="fas fa-long-arrow-alt-right" />
                </button>
              </div>

            </div>
          </div>

          <div className="question_6">
            <div className="question_and_numbers">
              <span>
                  Question 6 / 7
              </span>
              <p>
                Imagine that in the past few months
                , the overall stock market lose 25% Of
                its value. An individual stock investment you
                own also lost 25% of it value. What would you do?
              </p>
            </div>
            <div className="question_month_options">
              <div className="question_month_options_div">
                <div className="month_option"
                  onClick={() => this.onClickSixthQuestion(0)}
                >
                  <p>
                    Sell all of my shares
                  </p>
                </div>
                {
              !isEmpty(errorPhaseSix) ? (
                <ErrorAlertNotification
                  errors={errorPhaseSix.investmentLoosingValue}
                  onClick={this.handleDelete}
                />
              ) : ''
          }
                <div className="month_option"
                  onClick={() => this.onClickSixthQuestion(2)}
                >
                  <p>
                    Sell some of my shares
                  </p>
                </div>
                <div className="month_option"
                  onClick={() => this.onClickSixthQuestion(5)}
                >
                  <p>
                  Do nothing
                  </p>
                </div>
                <div className="month_option"
                  onClick={() => this.onClickSixthQuestion(8)}
                >
                  <p>
                    Buy more shares
                  </p>
                </div>
              </div>
            </div>

            <div className="next_question_btn">
              <div className="prev_btn">
                <button className="prev" type="button" id="back_to_question_five">
                  <i className="fas fa-long-arrow-alt-left" />
                  {' '}
Previous
                </button>
              </div>

              <div className="next_btn">
                <button className="next" type="button" id="to_question_seven">
                        Next
                  {' '}
                  <i className="fas fa-long-arrow-alt-right" />
                </button>

              </div>

            </div>
          </div>

          <div className="question_7">
            <div className="question_and_numbers">
              <span>
                Question 7 / 7
              </span>
              <p>
                We've outline the most likely best-case and worst-case
                annual returns of five hypothetical investment plans. Which
                range of possible outcomes is most acceptable to you.
              </p>
            </div>
            {
              !isEmpty(errorPhaseSeven) || !isEmpty(errors) || error ? (
                <ErrorAlertNotification
                  errors={errorPhaseSeven.annualReturns || errors || error}
                  onClick={this.handleDelete}
                />
              ) : ''
          }
            <div className="question_month_options">
              <div className="question_month_options_div">
                <div className="month_option"
                  onClick={() => this.onClickSeventhQuestion(0)}
                >
                  <p>
                    7.2%(Average) | 16.3%(Best-case) | -5.6%(Worst-case)
                  </p>
                </div>
                <br />
                <div className="month_option"
                  onClick={() => this.onClickSeventhQuestion(3)}
                >
                  <p>
                 9%(Average) | 25.0%(Best-case) | -12.1%(Worst-case)
                  </p>
                </div>
                <br />

                <div className="month_option"
                  onClick={() => this.onClickSeventhQuestion(6)}
                >
                  <p>
                 10.4%(Average) | 33.6%(Best-case) | -18.2%(Worst-case)
                  </p>
                </div>
                <div className="month_option"
                  onClick={() => this.onClickSeventhQuestion(8)}
                >
                  <p>
                 11.4%(Average) | 42.8%(Best-case) | -24.0%(Worst-case)
                  </p>
                </div>
                <div className="month_option"
                  onClick={() => this.onClickSeventhQuestion(10)}
                >
                  <p>
                 12.5%(Average) | 50.0%(Best-case) | -28.2%(Worst-case)
                  </p>
                </div>
              </div>
            </div>

            <div className="next_question_btn">

              <div className="prev_btn">
                <button className="prev" type="button" id="back_to_question_six">
                  <i className="fas fa-long-arrow-alt-left" />
                  {' '}
Previous
                </button>
              </div>

              <div className="next_btn">
                {
                isLoading ? (
                  <button
                    className="next"
                    type="button"
                //  id="last_phase"
                    onClick={this.onSubmit}
                  >
                    <i className="fa fa-spinner fa-spin" />
                    {'  '}
                            Next
                    {' '}
                    <i className="fas fa-long-arrow-alt-right" />
                  </button>
                ) : (
                  <button
                    className="next"
                    type="button"
                    // id="last_phase"
                    onClick={this.onSubmit}
                  >
                            Next
                    {' '}
                    <i className="fas fa-long-arrow-alt-right" />
                  </button>
                )
              }
              </div>
            </div>
          </div>

        </div>
      </section>
    );
    return (
      <>
        <DashboardMobileNav />
        <UserDashBoardSideNavigation />
        <div className="main_body_wrapper">
          <UserDashBoardTopNavigation />
          {questionaire}
        </div>
      </>
    );
  }
}

Questionaire.propTypes = {
  success: PropTypes.bool,
  error: PropTypes.string,
  isLoading: PropTypes.bool,
  DeleteRoboAdvisoryError: PropTypes.func,
  history: PropTypes.shape({}),
  RoboAdvisory: PropTypes.func,
};

const mapStateToProps = state => ({
  data: state.postRoboAdvisory.data,
  success: state.postRoboAdvisory.success,
  error: state.postRoboAdvisory.error,
  isLoading: state.postRoboAdvisory.loading,
});


export default withRouter(connect(mapStateToProps, {
  RoboAdvisory: roboAdvisory,
  DeleteRoboAdvisoryError: deleteRoboAdvisoryError
})(Questionaire));
